<div class="bg-white h-full">
  <router-outlet></router-outlet>
  <div style="position: relative !important"></div>
</div>
